import { useNavigate, useSearchParams } from 'react-router-dom'
import {
  LoginLocationState,
  appTargetSchema,
  coworkerHost,
  orchestraHost,
  projectSetupHost,
  targetDefaults
} from '../utils/authUtils'

const chosenAppSchema = appTargetSchema.optional().nullable().catch('dashboard')

export function useLoginRedirect() {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()

  const loginRedirect = ({ firstLogin }: LoginLocationState = {}) => {
    const chosenApp = chosenAppSchema.parse(searchParams.get('app'))
    const target =
      searchParams.get('target') ?? targetDefaults[chosenApp ?? 'dashboard']

    switch (chosenApp) {
      case 'project_setup':
        window.location.href =
          projectSetupHost + '/' + target.replace(/^\/+/g, '')
        break

      case 'coworker':
        window.location.href = coworkerHost + '/' + target.replace(/^\/+/g, '')
        break

      case 'orchestra':
        window.location.href = orchestraHost + '/' + target.replace(/^\/+/g, '')
        break

      case 'audience_picker':
        const isInsideIframe = window.self !== window.parent
        if (isInsideIframe) {
          window.parent.postMessage('reload', {
            targetOrigin:
              process.env.NODE_ENV === 'development'
                ? '*'
                : window.location.origin
          })
        } else {
          window.location.assign(target)
        }
        break

      default:
        navigate(target, { state: { firstLogin } })
    }
  }

  return { loginRedirect }
}
